import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { fetchBodyMapFailure, fetchBodyMapSuccess } from "./actions";
import { FETCH_BODYMAP } from "./constants";

/**
 * Body map = a live view over body-located observation_subjects (the feed).
 * The legacy rd_body_map add/edit/delete/view sagas are retired; recording an
 * observation (v2) is the only write path.
 */
export function* fetchBodyMapSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const residentId = payload?.resident_id;
  const filters = { ...(payload || {}) };
  delete filters.resident_id;
  delete filters.cancelToken;
  const query = QueryString.stringify(filters);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident/${residentId}/body-map${query ? `?${query}` : ""}`,
    );
    yield put(fetchBodyMapSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchBodyMapFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching body map!"));
  }
}

export function* fetchBodyMapFlow() {
  yield takeEvery(FETCH_BODYMAP, fetchBodyMapSaga);
}

export default function* ResidentBodyMapSaga() {
  yield all([fetchBodyMapFlow()]);
}
